import type { OptionsDocument, UserPreferences } from 'paintscout'
import { getFeature } from '../../options'
import uniq from 'lodash/uniq'

/**
 * Get follow ups from options or user based on settingsCommuncations feature
 */
export function getFollowUps({ preferences, options }: { preferences: UserPreferences; options: OptionsDocument }) {
  const hasSettingsCommunications = getFeature({ options, preferences, path: 'settingsCommunications.enabled' })
  if (hasSettingsCommunications) {
    const order = options.options?.emails?.followUps?.order ?? []
    return {
      order: uniq(order),
      values: options.options?.emails?.followUps?.values ?? {}
    }
  } else {
    const order = preferences?.emails?.followUps?.order ?? []
    return {
      order: uniq(order),
      values: preferences?.emails?.followUps?.values ?? {}
    }
  }
}
